export const useCraftGraphqlSlug = () => {
    const { variables: defaultVariables } = useCraftVariables();
    const route = useRoute();

    const variables = computed(() => ({
        ...toValue(defaultVariables),
        uri: null,
        slug: route.params.slug
    }));

    return {
        variables
    };
};
